/* eslint-disable */
import React, { Component } from "react";
import AgGridTable from "../../../components/common/agGridTable";
import ReadAxios from "../../../components/axiosComponent/read";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import {TA_MODULE, FEATURES} from '../../../utils/constant'
const padToFour = number => number <= 9999 ? `000${number}`.slice(-4) : number;

class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      loadingData: true,
    };
  }

  componentDidMount() {
    ReadAxios({ url: "userMaster" })
      .then((dataArray) => {
        let temp = []
        let tempArray = dataArray.data.resultSet.filter((item) => {
          return item.role != "Elixir"
        })
        temp.push(tempArray);
        console.log(temp);
        this.setState({
          rowData: temp[0],
          loadingData: false,
        }, () => console.log('rowdata', this.state.rowData));

      })
      .catch((err) => {
        console.log(err);
        this.setState({ loadingData: false, rowData: [] });
      });
  }

  onCellClicked = (rowData) => {
    if (this.props.permissions.TA_USER_MASTER.UPDATE == true) {
      typeof rowData.value != 'undefined' && this.onRowEdit(rowData.data);
    }
  }

  onRowEdit = (rowData) => {
    this.props.history.push("/edit-users", {
      ...rowData,
      title: "edit_title",
    });
  };

  onRowDelete = (alert) => {
    if (alert.type === "success") this.props.successAlert(alert);
    else this.props.errorAlert(alert);
    this.props.history.push("/users");
    this.props.history.go();
  };

  render() {
    console.log('rowdata in render', this.state.rowData)
    const { rowData } = this.state;
    const { t } = this.props;
    const Columns = [
      {
        headerName: t("table_header.user_code") || "User Code",
        field: "userCode",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.role") || "Role",
        field: "role",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.user_real_name") || "Name",
        field: "realname",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.username") || "User Name",
        field: "username",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.email_id") || "Email",
        field: "email_address",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.mobile_number") || "Phone",
        field: "mobile_number",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.created_by") || "Created By",
        field: "createdByName",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.created_on") || "Created On",
        field: "createdOnDate",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.updated_by") || "Updated By",
        field: "updatedByName",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.updated_on") || "Updated On",
        field: "updatedOnDate",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.edit_delete") || "Edit / Delete",
        field: "edit",
        cellRenderer: "actionRenderer",
        pinned: "right",
        suppressToolPanel: true,
        hide: !this.props.permissions.TA_USER_MASTER.UPDATE && !this.props.permissions.TA_USER_MASTER.DELETE,
      },
    ];
    return (
      <React.Fragment>
        <AgGridTable
          isLoading={this.state.loadingData}
          columnDefs={Columns}
          actionButton={false}
          rowData={rowData}
          titleBarTitle={this.props.t("title") || "Users"}
          titleBarLink={"/add-users"}
          baseURL={"userMaster"}
          pathName={"userMaster"}
          keyIndex={"u_id"}
          onEdit={this.onRowEdit}
          cellDoubleClicked={this.onCellClicked}
          onDelete={this.onRowDelete}
          hideRowEdit={!this.props.permissions.TA_USER_MASTER.UPDATE}
          hideRowDelete={!this.props.permissions.TA_USER_MASTER.DELETE}
          moduleName = {TA_MODULE}
          exportHidden={FEATURES.mastersExportDisabled()}
          suppressExcelExport={FEATURES.mastersExportDisabled()}
          suppressCsvExport={FEATURES.mastersExportDisabled()}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
    errorAlert: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(translate("user_list")(User));
